import { SharedState } from '@aiwyn/shared/state';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ROUTE_TOKEN_MAIN_BASE } from '../../../../routing-constants';
import { EngagementErrorDialogDataModel } from '../../models';

@Component({
  selector: 'app-engagement-error-dialog',
  templateUrl: './engagement-error-dialog.component.html',
  styleUrls: ['./engagement-error-dialog.component.scss'],
  standalone: false,
})
export class EngagementErrorDialogComponent implements OnInit {
  buttonIcon?: string;
  buttonText: string;
  errorCode: string;
  imagePath?: string;
  message: string;
  routePath: string | null;
  shouldShowSupportLink: boolean;
  title: string;
  copied = false;

  readonly version$ = this.store.select(SharedState.getVersion)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { concreteStrategy: EngagementErrorDialogDataModel },
    public dialogRef: MatDialogRef<EngagementErrorDialogComponent>,
    private readonly store: Store,
  ) {}

  ngOnInit() {
    this.title = this.data.concreteStrategy.getTitle();
    this.message = this.data.concreteStrategy.getMessage();
    this.imagePath = this.data.concreteStrategy?.getImagePath ? this.data.concreteStrategy.getImagePath() : undefined;
    this.buttonText = this.data.concreteStrategy.getButtonText();
    this.buttonIcon = this.data.concreteStrategy?.getButtonIcon ? this.data.concreteStrategy.getButtonIcon() : undefined;
    this.routePath = this.data.concreteStrategy.getRoutePath();
    this.errorCode = this.data.concreteStrategy?.errorCode;
    this.shouldShowSupportLink = !!this.data.concreteStrategy.shouldShowSupportLink;
  }

  copyErrorCode(): void {
    const value = this.errorCode ?? '';
    if (!value) {
      return;
    }

    // Prefer modern clipboard API when available (requires secure context).
    const clipboard = (globalThis as any)?.navigator?.clipboard;
    if (clipboard?.writeText) {
      clipboard.writeText(value)
        .then(() => this.showCopied())
      return;
    }

  }

  openSupportEmail(version: string): void {
    window.open(`mailto:support@aiwyn.ai?subject=Client Request for Support (${version})&body=Error Code: ${this.errorCode}`, '_blank');
  }

  onButtonClick(): void {
    const strategy = this.data.concreteStrategy;

    if (strategy.onButtonClick) {
      strategy.onButtonClick(this.dialogRef);
      return;
    }

    // Legacy fallback for strategies without onButtonClick
    if (this.routePath == '') {
      this.dialogRef.close();
      location.reload();
    } else if (this.routePath == null) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
      window.location.href = `${ROUTE_TOKEN_MAIN_BASE}/${this.routePath}`;
    }
  }

  private showCopied(): void {
    this.copied = true;
    setTimeout(() => (this.copied = false), 2000);
  }
}
